/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(categoryId) {
  var defer = $.Deferred();

  $.soap({
    body: {
      GetAllBankConversionNationalToStateLookups: {
        $xmlns: 'http://dobs.pa.gov/dp/lookup/bpm/1.0'
      }
    },
    blueprintArrays: [
      'GetAllBankConversionNationalToStateLookupsResponse.ConversionNationalToStateFederalCharters.DP_LU_ConversionNationalToStateFederalCharter',
      'GetAllBankConversionNationalToStateLookupsResponse.ConversionNationalToStateCorporateStructures.DP_LU_ConversionNationalToStateCorporateStructure',
      'GetAllBankConversionNationalToStateLookupsResponse.ConversionNationalToStateStateCharters.DP_LU_ConversionNationalToStateStateCharter',
      'GetAllBankConversionNationalToStateLookupsResponse.ConversionNationalToStateOwnershipStructures.DP_LU_ConversionNationalToStateOwnershipStructure'
    ],
    blueprint: {
      federalCharters: [
        '$..DP_LU_ConversionNationalToStateFederalCharter',
        {
          id: '$..ID',
          federalCharter: '$..FederalCharter'
        }
      ],
      corporateStructures: [
        '$..DP_LU_ConversionNationalToStateCorporateStructure',
        {
          id: '$..ID',
          corporateStructure: '$..CorporateStructure'
        }
      ],
      stateCharters: [
        '$..DP_LU_ConversionNationalToStateStateCharter',
        {
          id: '$..ID',
          stateCharter: '$..StateCharter'
        }
      ],
      ownershipStructures: [
        '$..DP_LU_ConversionNationalToStateOwnershipStructure',
        {
          id: '$..ID',
          ownershipStructure: '$..OwnershipStructure'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      defer.resolve(response);
    })
    .fail(function(err) {
      defer.reject(err);
    });

  return defer.promise();
};
